import {takeEvery} from 'redux-saga/effects'
import {
  ADD_SUBJECT_GROUP,
  DELETE_SUBJECT_GROUP,
  EDIT_SUBJECT_GROUP,
  GET_ALL_SUBJECT_GROUPS,
  GET_SUBJECT_GROUP_SINGLE,
} from 'setup/redux/Actions/SubjectGroup/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ALL_SUBJECT_GROUPS, fetchData)
  yield takeEvery(GET_SUBJECT_GROUP_SINGLE, fetchData)
  yield takeEvery(ADD_SUBJECT_GROUP, fetchData)
  yield takeEvery(EDIT_SUBJECT_GROUP, fetchData)
  yield takeEvery(DELETE_SUBJECT_GROUP, fetchData)
}

export default dataSaga
